module.exports = __webpack_public_path__ + "static/media/fish.6310f93a.jpg";